export default __webpack_public_path__ + "static/media/goalIcon.35a2cf44.svg";